import Swal from "sweetalert2";
import {Fancybox} from "@fancyapps/ui";
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import Swiper from "swiper";
import {EffectFade, Scrollbar, Autoplay, Navigation, Pagination, Thumbs, Grid} from 'swiper/modules';
import 'swiper/css/grid';
import 'swiper/css/effect-fade';
import lozad from 'lozad';
import flatpickr from 'flatpickr';
import {addToCart, initCart, initializeCartEvents, updateCartView} from "./eshop_new";

function getCSRFToken() {
    var cookieValue = null;
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith('csrftoken=')) {
            cookieValue = cookie.substring('csrftoken='.length, cookie.length);
            break;
        }
    }
    return cookieValue;
}

function filterTimeOptions(selectedDate) {
    const timeSelect = document.querySelector('#id_time');
    if (!timeSelect) return;
    timeSelect.value = '';
    const n = new Date();
    const isToday = selectedDate && selectedDate.toDateString() === n.toDateString();
    Array.from(timeSelect.options).forEach(opt => {
        if (!opt.value) return;
        if (!isToday) { opt.disabled = false; return; }
        const [h, m] = opt.value.split(':').map(Number);
        opt.disabled = h < n.getHours() || (h === n.getHours() && m <= n.getMinutes());
    });
    if (timeSelect._tsReset) timeSelect._tsReset();
}

function initTimeSelect() {
    const select = document.querySelector('#id_time');
    if (!select || select._tsInit) return;
    select._tsInit = true;
    select.style.display = 'none';

    const wrapper = document.createElement('div');
    wrapper.className = 'time-select';

    const trigger = document.createElement('div');
    trigger.className = 'time-select__trigger form__input form__select';
    trigger.textContent = select.options[0]?.text || 'Select a time';

    const dropdown = document.createElement('div');
    dropdown.className = 'time-select__dropdown';

    function renderOptions() {
        dropdown.innerHTML = '';
        Array.from(select.options).forEach(opt => {
            if (!opt.value || opt.disabled) return;
            const item = document.createElement('div');
            item.className = 'time-select__option' + (opt.value === select.value ? ' selected' : '');
            item.textContent = opt.text;
            item.addEventListener('click', () => {
                select.value = opt.value;
                trigger.textContent = opt.text;
                trigger.classList.add('has-value');
                wrapper.classList.remove('open');
                renderOptions();
            });
            dropdown.appendChild(item);
        });
    }

    select._tsReset = () => {
        trigger.textContent = select.options[0]?.text || 'Select a time';
        trigger.classList.remove('has-value');
        wrapper.classList.remove('open');
        renderOptions();
    };

    trigger.addEventListener('click', () => {
        renderOptions();
        wrapper.classList.toggle('open');
    });

    document.addEventListener('click', e => {
        if (!wrapper.contains(e.target)) wrapper.classList.remove('open');
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(dropdown);
    select.parentNode.insertBefore(wrapper, select);
    renderOptions();
}

function date_picker_init() {
    const dateInput = document.querySelector('.datepicker__input');
    if (!dateInput) return;

    if (dateInput._flatpickr) dateInput._flatpickr.destroy();

    const now = new Date();
    const minDay = now.getHours() >= 17
        ? new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
        : new Date(now.getFullYear(), now.getMonth(), now.getDate());

    flatpickr(dateInput, {
        dateFormat: 'Y-m-d',
        minDate: minDay,
        disableMobile: true,
        onChange(selectedDates) {
            filterTimeOptions(selectedDates[0] || null);
        }
    });
}

function initPhoneWidget() {}

function initIntlTelInput() {
    const input = document.querySelector("#id_phone");
    const submitButton = document.querySelector("#reserve-form button[type='submit']");
    if (!input || !submitButton) return;

    const phoneRegex = /^\+?[\d\s\-()\/.]{7,20}$/;

    function validate() {
        const valid = phoneRegex.test(input.value.trim());
        input.classList.toggle('valid', valid);
        input.classList.toggle('invalid', !valid && input.value.trim().length > 0);
        $('#phone-error').text(!valid && input.value.trim().length > 0 ? 'Invalid phone number' : '');
        submitButton.disabled = !valid;
    }

    input.addEventListener('input', validate);
    input.addEventListener('blur', validate);
    validate();

    const form = document.querySelector('#reserve-form');
    if (form) {
        form.addEventListener('submit', function () {
            submitButton.disabled = true;
        });
    }
}

function addToCard(count_selector, price_selector) {
    $('span.add-to-card').on('click', function (event) {
        event.preventDefault();

        let articleName = this.getAttribute('data-item-name');
        let articlePk = this.getAttribute('data-item-id');
        let articleCount = 1;
        let $this = $(this);

        if ($this.hasClass("loading")) {
            return;
        }

        $this.addClass("loading");

        addToCart(articlePk, articleCount)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Request failed with status ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                updateCartView(count_selector, price_selector, data);

                Swal.fire({
                    icon: 'success',
                    title: `${articleName} ${transDict['swalTitle']}`,
                    text: transDict['swalText'],
                    confirmButtonText: transDict['swalConfirmButtonText'],
                    showCloseButton: true,
                    footer: `<a href="${cardEditUrl}" data-type-link="go_to_cart">${transDict['swalFooter']}</a>`,
                    customClass: {
                        popup: 'popup-add-to-card'
                    }
                });
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: 'There was an error adding the product. Please try again.',
                    confirmButtonText: 'ОК'
                });
            })
            .finally(() => {
                $this.removeClass("loading");
            });
    });
}

(function ($) {
    $(document).ready(function () {

        const purchaseForm = document.querySelector('#purchase-form'),
            cartContainer = document.querySelector('#cart-items-container'),
            count_selector = '#total_count',
            price_selector = '#total_price'

        initCart(count_selector, price_selector);
        addToCard(count_selector, price_selector)

        if (cartContainer) {
            initializeCartEvents(cartContainer, updateCardUrl);
        }

        if (purchaseForm) {
            initPhoneWidget();
        }

        date_picker_init();
        initTimeSelect();
        initIntlTelInput();


        const observer = lozad();
        observer.observe();

        $('.navbar_toggler').on('click', function () {
            $(this).toggleClass('active')
            $('.header__container').toggleClass('active')
            $('.header nav').toggleClass('active')
        })

        $('.header nav a').on('click', function () {
            $('.header nav').removeClass('active')
            $('.header__container').removeClass('active')
            $('.navbar_toggler').removeClass('active')
        })

        $('.header .submenu_show .header__nav-link').on('click', function () {
            $(this).next().addClass('open')
            $(this).parent().addClass('open')
        })

        $('.header .header__nav-submenu--back').on('click', function () {
            $(this).parent().removeClass('open')
            $(this).parent().parent().removeClass('open')
        })

        const sectionSwiperParentSelector = document.querySelectorAll('.section__slider_wrap');
        sectionSwiperParentSelector.forEach((slider_wrap) => {
            const sectionSwiperSelector = slider_wrap.querySelector('.section__slider');
            if (sectionSwiperSelector != null) {
                const sectionSwiperPrev = slider_wrap.querySelector('.swiper-button-prev');
                const sectionSwiperNext = slider_wrap.querySelector('.swiper-button-next');
                const sectionSwiperPagination = slider_wrap.querySelector('.swiper-pagination');
                const sectionSwiper = new Swiper(sectionSwiperSelector, {
                    modules: [Navigation, Pagination],
                    slidesPerView: 1,
                    spaceBetween: 12,
                    navigation: {
                        prevEl: sectionSwiperPrev,
                        nextEl: sectionSwiperNext,
                    },
                    pagination: {
                        el: sectionSwiperPagination,
                        clickable: true,
                    },
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                            spaceBetween: 24,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 34,
                        },
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        }
                    }
                });
            }
        })

        const indexGallerySwiperSelector = document.querySelector('.index-gallery__slider');
        const indexGallerySwiper = new Swiper(indexGallerySwiperSelector, {
            modules: [Navigation, Pagination, Grid],
            slidesPerView: 1,
            spaceBetween: 12,
            navigation: {
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 34,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    grid: {
                        rows: 2,
                        fill: 'row'
                    },
                }
            }
        });

        const reviewsGallerySwiperSelector = document.querySelector('.reviews__slider');
        const reviewsGallerySwiper = new Swiper(reviewsGallerySwiperSelector, {
            modules: [Navigation, Pagination, Grid],
            slidesPerView: 1,
            spaceBetween: 12,
            navigation: {
                prevEl: ".reviews-button-prev",
                nextEl: ".reviews-button-next",
            },
            pagination: {
                el: '.reviews-pagination',
                clickable: true,
            },

            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                992: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                    grid: {
                        rows: 2,
                        fill: 'row'
                    },
                }
            }
        });

        const productGallerySwiperSelector = document.querySelector('.product-gallery__slider');
        const productGallerySwiper = new Swiper(productGallerySwiperSelector, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 12,
            navigation: {
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });

        const blogSwiperSelector = document.querySelector('.blog__slider');
        const blogSwiper = new Swiper(blogSwiperSelector, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 12,
            navigation: {
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 34,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                }
            }
        });

        const sliderMainSwiperSelector = document.querySelector('.swiper_gallery_main');
        const sliderTrumbSwiperSelector = document.querySelector('.swiper_gallery_trumb');

        if (sliderMainSwiperSelector != null && sliderTrumbSwiperSelector != null) {

            const ThumbSwiper = new Swiper(sliderTrumbSwiperSelector, {
                modules: [Grid],
                spaceBetween: 8,
                slidesPerView: 2,
                grid: {
                    rows: 3,
                    fill: 'row'
                },
                breakpoints: {
                    768: {}
                }
            });
            const mainSwiper = new Swiper(sliderMainSwiperSelector, {
                modules: [EffectFade, Navigation, Pagination, Thumbs],
                slidesPerView: 1,
                spaceBetween: 12,
                effect: "fade",
                thumbs: {
                    swiper: ThumbSwiper,
                },
                navigation: {
                    prevEl: ".swiper-button-prev",
                    nextEl: ".swiper-button-next",
                },
                pagination: {
                    el: ".swiper-pagination",
                    type: "fraction",
                },
            });
        }


        Fancybox.bind("[data-fancybox]");


        $('.anchor[href*="#"]:not([href="#"])').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                let target = $(this.hash);
                let menuHeight = $('header').outerHeight();
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - menuHeight
                    }, 1000);
                    return false;
                }
            }
        });


        const goToTopButton = $('.footer__go-to-top');

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > $(window).height()) {
                goToTopButton.fadeIn();
            } else {
                goToTopButton.fadeOut();
            }
        });

        goToTopButton.click(function (e) {
            e.preventDefault();
            $('html, body').animate({scrollTop: 0}, 1000);
        });


    });
}(jQuery));